import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const DubPreview = lazy(() => import("./DubPreview"));

export const dubPreviewRoutes: RouteObject[] = [
  {
    path: `project/:projectId/file/:fileId/dub/:dubId/preview`,
    element: <DubPreview />
  }
];
